module.exports = __webpack_public_path__ + "img/ticket.b89faeb1.svg";